import React from "react";
import { StriimMenuList, StriimMenuItem } from "@striim/striim-ui-v2";
import WithTooltip from "src/generic/tooltip/tooltip";

interface ConfigureDropdownProps {
    app?: any;
    onAppSettings?: () => void;
    onExport?: () => void;
    onMonitor?: () => void;
    onRecompile?: () => void;
    onGoToAutomationPipeline?: () => void;
    onViewValidationDashboard?: () => void;
    isAutomatedGroup?: boolean;
    disableRecompile?: boolean;
    setConfigDropdownOpen: (open: boolean) => void;
}

const ConfigureDropdown = ({
    app,
    onAppSettings,
    onExport,
    onMonitor,
    onRecompile,
    onGoToAutomationPipeline,
    onViewValidationDashboard,
    isAutomatedGroup,
    disableRecompile = false,
    setConfigDropdownOpen
}: ConfigureDropdownProps) => {
    return (
        <StriimMenuList>
            {onAppSettings && (
                <StriimMenuItem
                    onClick={() => {
                        onAppSettings();
                        setConfigDropdownOpen(false);
                    }}
                    data-test-id="option-App settings"
                >
                    App settings
                </StriimMenuItem>
            )}
            {onExport && (
                <StriimMenuItem
                    onClick={() => {
                        onExport();
                        setConfigDropdownOpen(false);
                    }}
                    data-test-id="option-Export"
                >
                    Export
                </StriimMenuItem>
            )}
            {onMonitor && (
                <StriimMenuItem
                    onClick={() => {
                        onMonitor();
                        setConfigDropdownOpen(false);
                    }}
                    data-test-id="option-Monitor"
                >
                    Monitor
                </StriimMenuItem>
            )}
            {onRecompile && (
                <>
                    {WithTooltip(
                        <StriimMenuItem
                            onClick={() => {
                                if (!disableRecompile) {
                                    onRecompile();
                                    setConfigDropdownOpen(false);
                                }
                            }}
                            data-test-id="option-Recompile"
                            disabled={disableRecompile}
                        >
                            Recompile
                        </StriimMenuItem>,
                        disableRecompile
                            ? "Application should be in Created state to recompile"
                            : "Recompiles this application",
                        false,
                        "left"
                    )}
                </>
            )}
            {isAutomatedGroup && onGoToAutomationPipeline && (
                <StriimMenuItem
                    onClick={() => {
                        onGoToAutomationPipeline();
                        setConfigDropdownOpen(false);
                    }}
                    data-test-id="option-Automation-pipeline"
                >
                    Go to the Automation Pipeline
                </StriimMenuItem>
            )}
            {onViewValidationDashboard && (
                <>
                    {WithTooltip(
                        <StriimMenuItem
                            onClick={() => {
                                onViewValidationDashboard();
                                setConfigDropdownOpen(false);
                            }}
                            data-test-id="option-Validation-dashboard"
                            disabled={!app?.isDataValidationEnabled}
                        >
                            View Validation Dashboard
                        </StriimMenuItem>,
                        app?.isDataValidationEnabled
                            ? "View Validation Dashboard"
                            : "Data validation is not enabled for this application",
                        false,
                        "left"
                    )}
                </>
            )}
        </StriimMenuList>
    );
};

export default ConfigureDropdown;
